import { useEffect, useState } from 'react'
import { getAIReview } from '../service'

export default function useUploadReview (uploadId) {
  const [data, setData] = useState(null)
  const [error, setError] = useState(false)
  const [attempt, setAttempt] = useState(0)
  useEffect(() => {
    let active = true
    setData(null)
    setError(false)
    if (uploadId) {
      getAIReview(uploadId).then(result => {
        if (active) setData(result)
      }).catch(() => { if (active) setError(true) })
    }
    return () => { active = false }
  }, [uploadId, attempt])
  return { data, error, retry: () => setAttempt(n => n + 1), saveFeedback: feedback => setData(current => current ? { ...current, feedback } : current), saveRatings: rows => setData(current => current ? { ...current, coaching_feedback: rows } : current) }
}
